import { getRequest, postRequest, putRequest, deleteRequest } from "../utils/apiHelper";

export interface LeadStatus {
  id: number;
  agency_id: number;
  name: string;
  label: string;
  color: string;
  is_default: boolean;
  sort_order: number;
  created_at: string;
  updated_at: string;
}

export interface LeadStatusCreate {
  name: string;
  label: string;
  color: string;
}

export interface LeadStatusUpdate {
  name?: string;
  label?: string;
  color?: string;
  sort_order?: number;
}

export async function getLeadStatuses(): Promise<LeadStatus[]> {
  try {
    const response = await getRequest("leads/statuses/list");
    return response?.data?.statuses || [];
  } catch (error) {
    console.error("Failed to fetch lead statuses:", error);
    return [];
  }
}

export async function createLeadStatus(data: LeadStatusCreate): Promise<LeadStatus | null> {
  try {
    const response = await postRequest("leads/statuses/create", data, false, undefined, 'default', null);
    return response?.data?.status || null;
  } catch (error) {
    console.error("Failed to create lead status:", error);
    throw error;
  }
}

export async function updateLeadStatus(
  statusName: string,
  updates: LeadStatusUpdate
): Promise<LeadStatus | null> {
  try {
    const response = await putRequest(`leads/statuses/${statusName}`, updates, false);
    return response?.data?.status || null;
  } catch (error) {
    console.error("Failed to update lead status:", error);
    throw error;
  }
}

export async function deleteLeadStatus(statusName: string): Promise<boolean> {
  try {
    await deleteRequest(`leads/statuses/${statusName}`, undefined, 'default');
    return true;
  } catch (error) {
    console.error("Failed to delete lead status:", error);
    throw error;
  }
}

export async function updateLeadStatusSortOrders(
  sortOrders: Record<string, number>
): Promise<LeadStatus[]> {
  try {
    const response = await postRequest("leads/statuses/sort-orders", { sortOrders }, false, undefined, 'default', null);
    return response?.data?.statuses || [];
  } catch (error) {
    console.error("Failed to update lead status sort orders:", error);
    throw error;
  }
}

export const leadStatusService = {
  getStatuses: getLeadStatuses,
  create: createLeadStatus,
  update: updateLeadStatus,
  delete: deleteLeadStatus,
  updateSortOrders: updateLeadStatusSortOrders,
};